import React from 'react';

interface FormSelectProps {
  label?: React.ReactNode;
  name: string;
  id?: string;
  value: string | number;
  onChange: (name: string, value: string) => void;
  children: React.ReactNode;
  className?: string;
}

// `id` defaults to `name`, but callers rendering the same field repeatedly per row in a list
// (e.g. one asset/liability among several of the same shape) MUST pass a row-unique `id` — a
// duplicate id breaks `<label for>` (clicking a label can focus the wrong row's select) and is
// invalid HTML regardless.
const FormSelect = ({ label, name, id, value, onChange, children, className }: FormSelectProps) => (
    <div className={className}>
        {label && <label htmlFor={id || name} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
        <select id={id || name} name={name} value={value} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(name, e.target.value)}
            className="w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100">
            {children}
        </select>
    </div>
);

export default FormSelect;
